export const MEDIA_QUERY_MAP = {
  xs: 'screen and (min-width: 23.4375em)',
  sm: 'screen and (min-width: 30em)',
  md: 'screen and (min-width: 48em)',
  lg: 'screen and (min-width: 62em)',
  xl: 'screen and (min-width: 80em)',
  xxl: 'screen and (min-width: 100em)',
};

// Defaults for server-side rendering
export const MEDIA_QUERY_DEFAULTS = {
  xs: true,
  sm: true,
  md: true,
  lg: true,
  xl: false,
  xxl: false,
};

export const MEDIA_QUERY_TABLET_DEFAULTS = {
  ...MEDIA_QUERY_DEFAULTS,
  lg: false,
};

export const MEDIA_QUERY_MOBILE_DEFAULTS = {
  ...MEDIA_QUERY_TABLET_DEFAULTS,
  md: false,
};

export const BREAKPOINT_BY_SCREEN_TYPE = {
  phone: 'xs',
  tablet: 'md',
  desktop: 'lg',
};

export const SCREEN_TYPES = {
  phone: 'phone',
  tablet: 'tablet',
  desktop: 'desktop',
  unknown: 'unknown',
};
